import axios from 'axios';

export const sendEmailDecider = async (commit, state, rootState, sendOptions) => {
  const { toSelected, ccSelected, bccSelected } = rootState.recipients;
  const { subject, body, files } = state;
  const { selectedEmailAccount } = rootState.emailAccounts;
  const commsAPIPhishingError = 'user flagged and blocked';

  const contactIds = toSelected.map(to => to.id);
  if (!contactIds.length) {
    commit('errorEmailScheduled', 'No contact selected to send an email');
    return;
  }

  const fileIds = files.map(file => file.id);
  let fromEmail;
  let senderEmail;

  if (selectedEmailAccount) {
    fromEmail = selectedEmailAccount.email;
    senderEmail = selectedEmailAccount.sender;
  }

  const payload = {
    subject,
    body,
    contact_id: contactIds,
    cc_contact_ids: ccSelected.map(cc => cc.id),
    bcc_contact_ids: bccSelected.map(bcc => bcc.id),
    file_ids: fileIds,
    sender: senderEmail,
    from: fromEmail,
    email_account_id: selectedEmailAccount ? selectedEmailAccount.id : 0,
    actionName: contactIds.length > 1 ? 'bulk' : 'single',
  };

  if (sendOptions.type === 'send_now') {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/email-send`,
        payload,
      );
      commit('setSuccessfulEmailSent', response.data.ids.length);
      return response;
    } catch (error) {
      const unsubscribedError = 'is unsubscribed';
      if (error.status === 400 && error.data.error === commsAPIPhishingError) {
        commit('setPhishingError', true);
      }
      if (error.data.error && error.data.error.includes(unsubscribedError)) {
        commit('errorContactUnsubscribed', true);
      } else {
        commit('errorEmailSent', toSelected);
      }
      return error;
    }
  }

  const schedulePayload = sendOptions.schedule;
  schedulePayload.input = JSON.stringify(payload);
  schedulePayload.contact_ids = payload.contact_id;
  schedulePayload.sent_from_fe = true;

  try {
    const response = await axios.post(
      `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/scheduled/system_event`,
      schedulePayload,
    );
    commit('setSuccessfulEmailScheduled', response.data.event_created);
    return response;
  } catch (error) {
    if (error.status === 400 && error.data.error === commsAPIPhishingError) {
      commit('setPhishingError', true);
    }
    commit('errorEmailScheduled', toSelected);
    return error;
  }
};
